import { useState } from 'react'; 
import { ConfigProvider } from './components/ConfigProvider'
import { AppMenu } from './components/AppMenu';
import { EncryptLocationPage } from './pages/EncryptLocationPage';
import { DecryptLocationPage } from './pages/DecryptLocationPage';
import { Settings } from './pages/Settings';


import './styles/index.less';

function App() {
  const [currentPage, setCurrentPage] = useState('encrypt');

  return (
    <ConfigProvider>
      <div id="wrapper">
        <AppMenu onPageChange={setCurrentPage} currentPage={currentPage} />

        {currentPage === 'encrypt' && <EncryptLocationPage />}
        {currentPage === 'decrypt' && <DecryptLocationPage />}
        {currentPage === 'settings' && <Settings />}
      </div>
    </ConfigProvider>
  );
}

export default App;
